(function () {
  if (window.__mmxSearchAndLoaded) return;
  window.__mmxSearchAndLoaded = true;

  // 2026-07-03 v2 — server-side AND for multi-word search.
  //
  // History: v0 "broadened" multi-term queries to the first word and filtered
  // client-side — fatally, only page 1 was ever filtered, so deep-ranked
  // matches (Citroen C5 interior sets) never appeared. v1 removed that and
  // used native search — correct top ranking, but Shopify's native multi-word
  // matching is OR-based, so "Citroen C5" returned all 88 Citroen products.
  //
  // v2 (this file): Shopify's storefront search treats QUOTED terms as
  // required — '"Citroen" "C5"' returns only products matching BOTH terms
  // (verified live: 17 results vs 88, identical for both term orders, and
  // year queries like '"BMW" "F30" "2015"' work because descriptions carry
  // compatibility text). So:
  //   • search form submits: every term gets quoted  → true AND, server-side,
  //     correct counts, correct pagination.
  //   • suggest AJAX (view=suggest): all COMPLETED terms get quoted, the last
  //     term stays bare so options[prefix]=last type-ahead keeps working
  //     ('"Citroen" C' → all Citroen C* products while typing).
  //   • queries where the user typed their own quotes are left untouched.
  //   • options[fields] injection kept from v1 — the theme's suggest AJAX
  //     omits it and Shopify's defaults exclude tag/body_html, which broke
  //     bare-SKU lookups like "10209".
  //   • on the results page the search input shows the clean unquoted query.

  function quoteTerms(q, keepLastBare) {
    if (!q || q.indexOf('"') !== -1) return q; // user's own quotes win
    var terms = q.trim().split(/\s+/).filter(function (t) { return t.length > 0; });
    if (terms.length < 2) return q;
    var out = [];
    for (var i = 0; i < terms.length; i++) {
      var bare = keepLastBare && i === terms.length - 1;
      out.push(bare ? terms[i] : '"' + terms[i] + '"');
    }
    return out.join(' ');
  }

  function unquote(q) {
    return (q || '').replace(/"/g, '');
  }

  function rewriteSearchUrl(url) {
    try {
      var urlObj = new URL(url, window.location.href);
      if (urlObj.pathname.indexOf('/search') === -1) return url;
      var modified = false;
      var isSuggest = urlObj.searchParams.get('view') === 'suggest';
      if (isSuggest && !urlObj.searchParams.get('options[fields]')) {
        urlObj.searchParams.set('options[fields]', 'title,product_type,variants.title,variants.sku,tag,vendor,body_html');
        modified = true;
      }
      var q = urlObj.searchParams.get('q') || '';
      // Suggest calls fire mid-typing: keep the last (possibly partial) term
      // bare for prefix matching. Full searches quote everything.
      var newQ = quoteTerms(q, isSuggest);
      if (newQ !== q) {
        urlObj.searchParams.set('q', newQ);
        modified = true;
      }
      if (modified) {
        return urlObj.pathname + '?' + urlObj.searchParams.toString();
      }
    } catch (e) {}
    return url;
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    var args = Array.prototype.slice.call(arguments);
    if (typeof args[1] === 'string') args[1] = rewriteSearchUrl(args[1]);
    return origOpen.apply(this, args);
  };

  if (typeof window.fetch === 'function') {
    var origFetch = window.fetch;
    window.fetch = function (resource, options) {
      if (typeof resource === 'string') resource = rewriteSearchUrl(resource);
      return origFetch.call(this, resource, options);
    };
  }

  // Quote terms on real form submits (capture phase so we run before the
  // theme's own handlers). The rewritten value lands in the URL; the visible
  // input is restored on the results page below.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || (form.getAttribute('action') || '').indexOf('/search') === -1) return;
    var qInput = form.querySelector('[name="q"]');
    if (!qInput) return;
    qInput.value = quoteTerms(qInput.value, false);
  }, true);

  // On the results page, show the clean query in search boxes instead of the
  // quoted form Shopify echoes back.
  function cleanInputs() {
    var q = new URLSearchParams(window.location.search).get('q') || '';
    if (q.indexOf('"') === -1) return;
    var clean = unquote(q);
    var inputs = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.indexOf('"') !== -1) inputs[i].value = clean;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanInputs);
  } else {
    cleanInputs();
  }
})();
